import { render, staticRenderFns } from "./cClientList.vue?vue&type=template&id=b1a3dd34&scoped=true"
import script from "./cClientList.vue?vue&type=script&lang=js"
export * from "./cClientList.vue?vue&type=script&lang=js"
import style0 from "./cClientList.vue?vue&type=style&index=0&id=b1a3dd34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a3dd34",
  null
  
)

export default component.exports